export default "__VITE_ASSET__3GYp3tRh__"